module.exports = __webpack_public_path__ + "img/homeList5.aee5de42.png";